import { LoadingOverlayComponent } from '../shared/components/loading-overlay/loading-overlay.component';

import { AuthService } from '../auth/auth.service';
import { WarningService, WarnSeason } from './warning.service';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/fontawesome-svg-core';

import moment from 'moment';

export const MODULES = [
  CommonModule,
  MatTabsModule,
  RouterModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent];

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  imports: [...MODULES, ...COMPONENTS, LoadingOverlayComponent],
})
export class WarningComponent implements OnInit {
  public warningService = inject(WarningService);
  private auth = inject(AuthService);

  isLoading = signal(true);
  numberOfWarnings = 20;

  navLinks = [
    {
      location: '/warning/current',
      label: 'ACTIVE',
      icon: 'exclamation-triangle' as IconName,
    },
    {
      location: '/warning/timeline',
      label: 'HISTORY',
      icon: 'list' as IconName,
    },
  ];

  static getOrderedSeasons(): Array<WarnSeason> {
    const currentMonth = moment().month();
    if (currentMonth > 2 && currentMonth < 9) {
      return [WarnSeason.SUMMER, WarnSeason.WINTER];
    }
    return [WarnSeason.WINTER, WarnSeason.SUMMER];
  }

  ngOnInit(): void {
    this.initWarnRegions();
  }

  async initWarnRegions(): Promise<void> {
    const egwProducts = {
      summer: [],
      winter: [],
    };
    this.warningService.seasons.set([...WarningComponent.getOrderedSeasons()]);
    for (const season of this.warningService.seasons()) {
      const customerDocument = this.auth.getCustomerDocument();
      const productType =
        season === WarnSeason.WINTER ? 'egwProducts' : 'egwSummerProducts';
      const allCustomersEgwProducts = customerDocument[productType];
      egwProducts[season] = allCustomersEgwProducts.filter(product =>
        this.auth.isProductActive(productType, product.id)
      );
      this.warningService.hasWarningProducts[season] =
        egwProducts[season].length;
    }
    await this.warningService.extractWarnRegionsSummer(egwProducts.summer);
    await this.warningService.extractWarnRegionsWinter(egwProducts.winter);
    this.prioritizeCurrentWarnings();
    this.isLoading.set(false);
  }

  prioritizeCurrentWarnings(): void {
    this.warningService.sortedWarningData.set([]);
    const warnTypes = ['WARN', 'VORAB', 'ENTWARN', 'AUTOENTWARN', 'NOWARN'];
    const warningsPerType = {
      WARN: [],
      VORAB: [],
      ENTWARN: [],
      AUTOENTWARN: [],
      NOWARN: [],
    };
    for (const season of this.warningService.seasons()) {
      if (this.warningService.hasWarningProducts[season] > 0) {
        for (const warnRegion of this.warningService.warnRegions()[season]) {
          let i = 0;
          let wasENTWARN = false;
          for (const warningData of this.warningService.allWarningData()[
            season
          ][warnRegion.id]) {
            const warnType = warningData.type;
            if (warnType === 'ENTWARN' || warnType === 'AUTOENTWARN') {
              wasENTWARN = true;
            }
            if (
              i > 0 &&
              this.warningService.allWarningData()[season][warnRegion.id][i - 1]
                .type === warnType
            ) {
              break;
            }
            if (warnType === 'WARN' && wasENTWARN) {
              continue;
            }
            warningsPerType[warnType].push({
              region: warnRegion,
              warning: warningData,
            });
            if (season === 'winter' || i > 0) {
              break;
            }
            i++;
            if (i > 1) {
              break;
            }
          }
        }
      }
    }
    for (const warnType of warnTypes) {
      for (const warningData of warningsPerType[warnType]) {
        if (!this.warningService.selectedRegion()) {
          this.warningService.selectedRegion.set({ ...warningData.region });
        }
        this.warningService.sortedWarningData.update(sortedWarningData => {
          return [...sortedWarningData, warningData];
        });
      }
    }
  }
}
